let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6D4FW")).then(() => parcelRequire('6z8GT'));